export default "__VITE_ASSET__qqLYu3e5__"